import type { AudioPreset } from 'livekit-client';

/**
 * Preset de áudio da reunião: Opus mono 32 kbps.
 *
 * O default do livekit-client é `AudioPresets.music` (48 kbps). Com RED ligado (2 cópias
 * do pacote para resistir a perda) o áudio chegava a ~100 kbps de uplink — relevante quando
 * câmera + tela já disputam um link residencial. 32 kbps é o que Meet/Zoom usam para voz
 * e continua transparente para fala; RED/DTX ficam ligados.
 */
export const MEETING_AUDIO_MAX_BITRATE = 32_000;

export const MEETING_AUDIO_PRESET: AudioPreset = {
  maxBitrate: MEETING_AUDIO_MAX_BITRATE,
};
